module.exports = __webpack_public_path__ + "img/bottle.be5030ca.webp";